import { useField } from 'formik';

import { TextTip } from '@@/Tip/TextTip';
import { FormControl } from '@@/form-components/FormControl';
import { FormSection } from '@@/form-components/FormSection';
import { Input } from '@@/form-components/Input';
import { ExternalLink } from '@@/ExternalLink';
import { Link } from '@@/Link';

export function HelmSection() {
  const [{ value, onChange, name, onBlur }, { error }] =
    useField<string>('helmRepositoryURL');

  return (
    <FormSection title="Helm repository">
      <div className="mb-2">
        <TextTip color="blue">
          You can specify the URL to your own{' '}
          <ExternalLink
            to="https://helm.sh/docs/topics/chart_repository/"
            data-cy="helm-repository-link"
          >
            Helm repository
          </ExternalLink>{' '}
          here. To add an{' '}
          <ExternalLink
            to="https://helm.sh/docs/topics/registries/"
            data-cy="helm-oci-registry-link"
          >
            OCI registry
          </ExternalLink>
          , navigate to the{' '}
          <Link to="portainer.registries" data-cy="helm-registries-link">
            Registries view
          </Link>
          .
        </TextTip>
      </div>

      <FormControl label="URL" errors={error} inputId="helm-repo-url">
        <Input
          id="helm-repo-url"
          data-cy="helm-repo-url-input"
          name={name}
          placeholder="https://kubernetes.github.io/ingress-nginx"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
        />
      </FormControl>
    </FormSection>
  );
}
